export default __webpack_public_path__ + "img/mpc-showcase.ef46f4a2.png";